export default __webpack_public_path__ + "static/bg-boxes--mobile-ade4f394da6e4e326ce964047b353560.webp";